import { render, staticRenderFns } from "./TitleBox.vue?vue&type=template&id=5717b533&scoped=true"
import script from "./TitleBox.vue?vue&type=script&lang=js"
export * from "./TitleBox.vue?vue&type=script&lang=js"
import style0 from "./TitleBox.vue?vue&type=style&index=0&id=5717b533&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5717b533",
  null
  
)

export default component.exports